<!-- <div class="home-background">
    <div class="container-home">

        <div class="container">


            

        </div>
    </div>
</div> -->


<div class="home-div home-top">

</div>
<div class="container-main-home">
    <div class="container animate__animated animate__fadeIn ">
        <div
            [ngClass]="isMobileXL() ? 'd-flex flex-column align-items-center' : 'd-flex align-items-center justify-content-evenly'">

            <!-- <button (click)="test()" mat-flat-button> test</button> -->

        </div>



    </div>

</div>

<div class="home-bottom">
    <div class=" d-flex justify-content-center gap-2 mb-4 footer-home">
        <p class="p-ayuda">¿Necesitás Ayuda?</p>
        <a class="hyperlink-pie-home" href="mailto:{{Etiquetas.MailContacto}}">Contactate con nosotros</a>
    </div>
</div>